export const notesArray = [
  {
    itemTitle: "Array data structure",
    subject: "Data Structure",
    timeOfposting: "10:30 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    itemTitle: "String in java",
    subject: "Java Programming",
    timeOfposting: "2:30 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1573496774379-b930dba17d8b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZlbWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
];

export const tasksArray = [
  {
    itemTitle: "Answer all the questions",
    subject: "Discrete Mathematics",
    timeOfposting: "10:30 am",
    status: "submitted",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    taskFile: "assignment ca1",
  },
  {
    itemTitle: "Join these two tables",
    subject: "Database",
    timeOfposting: "yesterday",
    status: "pending",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1573496774379-b930dba17d8b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZlbWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    taskFile: "assignment2",
  },
];

export const classesArray = [
  {
    itemTitle: "Sql Quarries",
    subject: "Database",
    timeOfposting: "9:30 am",
    status: "finished",
    nameOfPoster: "Satyajit Sahoo",
  },
  {
    itemTitle: "Graph thoery",
    subject: "Discrete",
    timeOfposting: "1:30 pm",
    status: "ongoing",
    nameOfPoster: "Debnarayan Khatua",
  },
  {
    itemTitle: "Threads in Java",
    subject: "Java",
    timeOfposting: "2:30 pm",
    status: "not-started",
    nameOfPoster: "Dipankar Dey",
  },
];

export const doubtsArray = [
  {
    itemTitle: "How to use super constructor",
    subject: "Java Programming",
    timeOfposting: "9:15 am",
    nameOfPoster: "Soumen Sau",
  },
  {
    itemTitle: "Difference between left join",
    subject: "Database",
    timeOfposting: "7:15 am",
    nameOfPoster: "Abhik Das",
  },
  {
    itemTitle: "What is the formula for number",
    subject: "Discrete Mathematics",
    timeOfposting: "yesterday",
    nameOfPoster: "Rabbil Khan",
  },
];

export const allClassesArray = [
  {
    subject: "Data Structure",
    teacher: "Samiran Pal",
    classTime: "9:30 am",
    bgColor: "rgba(94, 208, 88, 0.35)",
    textColor: "rgba(94, 208, 88, 1)",
  },
  {
    subject: "Discrete Math",
    teacher: "Debnarayan K",
    classTime: "10:30 am",
    bgColor: "rgba(255, 196, 0, 0.35)",
    textColor: "rgba(255, 196, 0, 1)",
  },
  {
    subject: "Java Programming",
    teacher: "Dipankar Dey",
    classTime: "12:30 pm",
    bgColor: "rgba(114, 223, 238, 0.35)",
    textColor: "rgba(114, 223, 238, 1)",
  },
  {
    subject: "Database",
    teacher: "Satyajit Sahoo",
    classTime: "1:30 pm",
    bgColor: "rgba(239, 139, 62, 0.35)",
    textColor: "rgba(239, 139, 62, 1)",
  },
  {
    subject: "Data Structure",
    teacher: "Samiran Pal",
    classTime: "9:30 am",
    bgColor: "rgba(94, 208, 88, 0.35)",
    textColor: "rgba(94, 208, 88, 1)",
  },
  {
    subject: "Discrete Math",
    teacher: "Debnarayan K",
    classTime: "10:30 am",
    bgColor: "rgba(255, 196, 0, 0.35)",
    textColor: "rgba(255, 196, 0, 1)",
  },
  {
    subject: "Java Programming",
    teacher: "Dipankar Dey",
    classTime: "12:30 pm",
    bgColor: "rgba(114, 223, 238, 0.35)",
    textColor: "rgba(114, 223, 238, 1)",
  },
  {
    subject: "Database",
    teacher: "Satyajit Sahoo",
    classTime: "1:30 pm",
    bgColor: "rgba(239, 139, 62, 0.35)",
    textColor: "rgba(239, 139, 62, 1)",
  },
];

export const materialArray = [
  {
    itemTitle: "Array data structure",
    postedBy: "Samiran Pal",
    subject: "Data Structure",
    timeOfposting: "10:30 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    itemTitle: "String in java",
    postedBy: "Dipankar Dey",
    subject: "Java Programming",
    timeOfposting: "2:30 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Graph theory notes",
    postedBy: "Debnarayan Khatua",
    subject: "Discrete Math",
    timeOfposting: "Wednesday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
  },
  {
    itemTitle: "notes taking",
    postedBy: "Suvanggi Biswas",
    subject: "English Communication",
    timeOfposting: "Oct 15th",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "some notes about architecture",
    postedBy: "Maidul Islam",
    subject: "Computer Architecture",
    timeOfposting: "Nov 2nd",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Array, Linked List",
    postedBy: "Samiran Pal",
    subject: "Data Structure",
    timeOfposting: "10:30 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    itemTitle: "OOPS concept",
    postedBy: "Dipankar Dey",
    subject: "Java Programming",
    timeOfposting: "2:30 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Class 21 study Material ",
    postedBy: "Debnarayan Khatua",
    subject: "Discrete Math",
    timeOfposting: "Wednesday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
  },
  {
    itemTitle: "Presentation Notes",
    postedBy: "Suvanggi Biswas",
    subject: "English Communication",
    timeOfposting: "Oct 15th",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Computer Instruction Notes",
    postedBy: "Maidul Islam ",
    subject: "Computer Architecture",
    timeOfposting: "Nov 2nd",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Recent Class Notes",
    postedBy: "Samiran Pal",
    subject: "Data Structure",
    timeOfposting: "10:30 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    itemTitle: "Loop Notes",
    postedBy: "Dipankar Dey",
    subject: "Java Programming",
    timeOfposting: "2:30 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Tree Notes",
    postedBy: "Debnarayan Khatua",
    subject: "Discrete Math",
    timeOfposting: "Wednesday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
  },
  {
    itemTitle: "Business Communication",
    postedBy: "Suvanggi Biswas",
    subject: "English Communication",
    timeOfposting: "Oct 15th",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "High level Language",
    postedBy: "Maidul Islam",
    subject: "Computer Architecture",
    timeOfposting: "Nov 2nd",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Heap Graph Matrix",
    postedBy: "Samiran Pal",
    subject: "Data Structure",
    timeOfposting: "10:30 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    itemTitle: "Class 19 Study Materials",
    postedBy: "Dipankar Dey",
    subject: "Java Programming",
    timeOfposting: "2:30 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Class 23 Study Materials",
    postedBy: "Debnarayan Khatua",
    subject: "Discrete Math",
    timeOfposting: "Wednesday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
  },
  {
    itemTitle: "Class 14 Study Materials",
    postedBy: "Suvanggi Biswas",
    subject: "English Communication",
    timeOfposting: "Oct 15th",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Study Materials",
    postedBy: "Maidul Islam",
    subject: "Computer Architecture",
    timeOfposting: "Nov 2nd",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "advance data structure notes",
    postedBy: "Samiran Pal",
    subject: "Data Structure",
    timeOfposting: "10:30 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    itemTitle: "Java Clss Attributes",
    postedBy: "Dipankar Dey",
    subject: "Java Programming",
    timeOfposting: "2:30 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Set and Ratio",
    postedBy: "Debnarayan Khatua",
    subject: "Discrete Math",
    timeOfposting: "Wednesday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
  },
  {
    itemTitle: "Accuracy Notes",
    postedBy: "Suvanggi Biswas",
    subject: "English Communication",
    timeOfposting: "Oct 15th",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
  },
  {
    itemTitle: "Computer Design",
    postedBy: "Maidul Islam",
    subject: "Computer Architecture",
    timeOfposting: "Nov 2nd",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
];

export const taskArray = [
  {
    itemTitle: "CA1 Assignment",
    postedBy: "Samiran Pal ",
    subject: "Data Structure",
    dueDate: "Due Monday",
    timeOfposting: "yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1573496774379-b930dba17d8b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZlbWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "submitted",
  },
  {
    itemTitle: "PCA1 Assignment",
    postedBy: "Dipankar Dey ",
    subject: "Java Programming",
    dueDate: "Due Tommorow",
    timeOfposting: "Sep 26",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "CA1 Assignment",
    postedBy: "Debnarayan Khatua ",
    subject: "Discrete Math",
    dueDate: "Due Wednesday",
    timeOfposting: "09:55 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "submitted",
  },
  {
    itemTitle: "CA2 Assignment",
    postedBy: "Suvanggi Biswas ",
    subject: "English Communication",
    dueDate: "Due Saturday",
    timeOfposting: "08:30 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "PCA1 Assignment",
    postedBy: "Maidul Islam ",
    subject: "Computer Architecture",
    dueDate: "Due Wednesday",
    timeOfposting: "Nov 2nd",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "Home Task",
    postedBy: "Samiran Pal ",
    subject: "Data Structure",
    dueDate: "Due Today",
    timeOfposting: "01:00 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1573496774379-b930dba17d8b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZlbWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "pending",
  },
  {
    itemTitle: "Home Task",
    postedBy: "Dipankar Dey ",
    subject: "Java Programming",
    dueDate: "Due Sunday",
    timeOfposting: "03:12 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "Home Task",
    postedBy: "Debnarayan Khatua ",
    subject: "Discrete Math",
    dueDate: "Due Friday",
    timeOfposting: "12:46 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "pending",
  },
  {
    itemTitle: "Home Task",
    postedBy: "Suvanggi Biswas ",
    subject: "English Communication",
    dueDate: "Due Tuesday",
    timeOfposting: "11:35 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "Home Task",
    postedBy: "Maidul Islam ",
    subject: "Computer Architecture",
    dueDate: "Due Thursday",
    timeOfposting: "08:05 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "CA2 Assignment",
    postedBy: "Samiran Pal ",
    subject: "Data Structure",
    dueDate: "Due 10:30 am",
    timeOfposting: "09:00 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1573496774379-b930dba17d8b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZlbWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "pending",
  },
  {
    itemTitle: "CA2 Assignment",
    postedBy: "Dipankar Dey ",
    subject: "Java Programming",
    dueDate: "Due Wednesday",
    timeOfposting: "Oct 1st",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "CA2 Assignment",
    postedBy: "Debnarayan Khatua ",
    subject: "Discrete Math",
    dueDate: "Due Tuesday",
    timeOfposting: "11:23 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "pending",
  },
  {
    itemTitle: "CA1 Assignment",
    postedBy: "Suvanggi Biswas ",
    subject: "English Communication",
    dueDate: "Due Monday",
    timeOfposting: "Sep 29th",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "CA2 Assignment",
    postedBy: "Maidul Islam ",
    subject: "Computer Architecture",
    dueDate: "Due Wednesday",
    timeOfposting: "Nov 21th",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "PCA1 Assignment",
    postedBy: "Samiran Pal ",
    subject: "Data Structure",
    dueDate: "Due Sunday",
    timeOfposting: "09:56 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1573496774379-b930dba17d8b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZlbWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "pending",
  },
  {
    itemTitle: "Home Task",
    postedBy: "Dipankar Dey ",
    subject: "Java Programming",
    dueDate: "Due Today",
    timeOfposting: "Sep 23",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "PCA1 Assignment",
    postedBy: "Debnarayan Khatua ",
    subject: "Discrete Math",
    dueDate: "Due Today",
    timeOfposting: "07:34 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "pending",
  },
  {
    itemTitle: "PCA1 Assignment",
    postedBy: "Suvanggi Biswas ",
    subject: "English Communication",
    dueDate: "Due 05:00 pm",
    timeOfposting: "Friday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "Home Task",
    postedBy: "Maidul Islam ",
    subject: "Computer Architecture",
    dueDate: "Due 10:30 am",
    timeOfposting: "Thursday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "Today's Class Homework",
    postedBy: "Samiran Pal ",
    subject: "Data Structure",
    dueDate: "Due Monday",
    timeOfposting: "yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1573496774379-b930dba17d8b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZlbWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "pending",
  },
  {
    itemTitle: "Today's Class Homework",
    postedBy: "Dipankar Dey ",
    subject: "Java Programming",
    dueDate: "Due Tommorow",
    timeOfposting: "Sep 26",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "Today's Class Homework",
    postedBy: "Debnarayan Khatua ",
    subject: "Discrete Math",
    dueDate: "Due Wednesday",
    timeOfposting: "09:55 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    status: "pending",
  },
  {
    itemTitle: "Today's Class Homework",
    postedBy: "Suvanggi Biswas ",
    subject: "English Communication",
    dueDate: "Due Saturday",
    timeOfposting: "08:30 pm",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
  {
    itemTitle: "Today's Class Homework",
    postedBy: "Maidul Islam ",
    subject: "Computer Architecture",
    dueDate: "Due Wednesday",
    timeOfposting: "Nov 2nd",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    status: "pending",
  },
];

export const allDoubtsArray = [
  {
    itemTitle: "How to implement queue using only stack?",
    postedBy: "Soumen Sau",
    subject: "Data Structure",
    timeOfposting: "11:25",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    votes: 21,
    doubtDesc:
      "Can anyone tell me how to how to implement a queue data structure using only stack. Implement a first in first out (FIFO) queue using only two stacks. The implemented queue should support all the functions of a normal queue (push, peek, pop, and empty). You must use only standard operations of a stack, which means only push to top, peek/pop from top, size, and is empty operations are valid. Depending on your language, the stack may not be supported natively. You may simulate a stack using a list or deque (double-ended queue) as long as you use only a stack's standard operations.",
  },
  {
    itemTitle: "What is bipartite graph",
    postedBy: "Rabbil Khan",
    subject: "Discrete Math",
    timeOfposting: "8:54 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 15,
    doubtDesc:
      "Please anyone tell what exactly is bipartite graph with proper examples.",
  },
  {
    itemTitle: "Difference between internal and external view.",
    postedBy: "Biswanath Bera",
    subject: "Database",
    timeOfposting: "Yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
    votes: 8,
    doubtDesc:
      "What is the difference between internal view and external view in database? Please give at least 5 to 7 differnces. If you can provide examples that will be great.",
  },
  {
    itemTitle: "How to implement queue using only stack?",
    postedBy: "Soumen Sau",
    subject: "Data Structure",
    timeOfposting: "11:25",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 21,
    doubtDesc:
      "Can anyone tell me how to how to implement a queue data structure using only stack. Implement a first in first out (FIFO) queue using only two stacks. The implemented queue should support all the functions of a normal queue (push, peek, pop, and empty). You must use only standard operations of a stack, which means only push to top, peek/pop from top, size, and is empty operations are valid. Depending on your language, the stack may not be supported natively. You may simulate a stack using a list or deque (double-ended queue) as long as you use only a stack's standard operations.",
  },
  {
    itemTitle: "What is bipartite graph",
    postedBy: "Rabbil Khan",
    subject: "Discrete Math",
    timeOfposting: "8:54 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    votes: 15,
    doubtDesc:
      "Please anyone tell what exactly is bipartite graph with proper examples.",
  },
  {
    itemTitle: "Difference between internal and external view.",
    postedBy: "Biswanath Bera",
    subject: "Database",
    timeOfposting: "Yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    votes: 8,
    doubtDesc:
      "What is the difference between internal view and external view in database? Please give at least 5 to 7 differnces. If you can provide examples that will be great.",
  },
  {
    itemTitle: "How to implement queue using only stack?",
    postedBy: "Soumen Sau",
    subject: "Data Structure",
    timeOfposting: "11:25",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 21,
    doubtDesc:
      "Can anyone tell me how to how to implement a queue data structure using only stack. Implement a first in first out (FIFO) queue using only two stacks. The implemented queue should support all the functions of a normal queue (push, peek, pop, and empty). You must use only standard operations of a stack, which means only push to top, peek/pop from top, size, and is empty operations are valid. Depending on your language, the stack may not be supported natively. You may simulate a stack using a list or deque (double-ended queue) as long as you use only a stack's standard operations.",
  },
  {
    itemTitle: "What is bipartite graph",
    postedBy: "Rabbil Khan",
    subject: "Discrete Math",
    timeOfposting: "8:54 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
    votes: 15,
    doubtDesc:
      "Please anyone tell what exactly is bipartite graph with proper examples.",
  },
  {
    itemTitle: "Difference between internal and external view.",
    postedBy: "Biswanath Bera",
    subject: "Database",
    timeOfposting: "Yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 8,
    doubtDesc:
      "What is the difference between internal view and external view in database? Please give at least 5 to 7 differnces. If you can provide examples that will be great.",
  },
  {
    itemTitle: "How to implement queue using only stack?",
    postedBy: "Soumen Sau",
    subject: "Data Structure",
    timeOfposting: "11:25",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    votes: 21,
    doubtDesc:
      "Can anyone tell me how to how to implement a queue data structure using only stack. Implement a first in first out (FIFO) queue using only two stacks. The implemented queue should support all the functions of a normal queue (push, peek, pop, and empty). You must use only standard operations of a stack, which means only push to top, peek/pop from top, size, and is empty operations are valid. Depending on your language, the stack may not be supported natively. You may simulate a stack using a list or deque (double-ended queue) as long as you use only a stack's standard operations.",
  },
  {
    itemTitle: "What is bipartite graph",
    postedBy: "Rabbil Khan",
    subject: "Discrete Math",
    timeOfposting: "8:54 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    votes: 15,
    doubtDesc:
      "Please anyone tell what exactly is bipartite graph with proper examples.",
  },
  {
    itemTitle: "Difference between internal and external view.",
    postedBy: "Biswanath Bera",
    subject: "Database",
    timeOfposting: "Yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 8,
    doubtDesc:
      "What is the difference between internal view and external view in database? Please give at least 5 to 7 differnces. If you can provide examples that will be great.",
  },
  {
    itemTitle: "How to implement queue using only stack?",
    postedBy: "Soumen Sau",
    subject: "Data Structure",
    timeOfposting: "11:25",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
    votes: 21,
    doubtDesc:
      "Can anyone tell me how to how to implement a queue data structure using only stack. Implement a first in first out (FIFO) queue using only two stacks. The implemented queue should support all the functions of a normal queue (push, peek, pop, and empty). You must use only standard operations of a stack, which means only push to top, peek/pop from top, size, and is empty operations are valid. Depending on your language, the stack may not be supported natively. You may simulate a stack using a list or deque (double-ended queue) as long as you use only a stack's standard operations.",
  },
  {
    itemTitle: "What is bipartite graph",
    postedBy: "Rabbil Khan",
    subject: "Discrete Math",
    timeOfposting: "8:54 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 15,
    doubtDesc:
      "Please anyone tell what exactly is bipartite graph with proper examples.",
  },
  {
    itemTitle: "Difference between internal and external view.",
    postedBy: "Biswanath Bera",
    subject: "Database",
    timeOfposting: "Yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    votes: 8,
    doubtDesc:
      "What is the difference between internal view and external view in database? Please give at least 5 to 7 differnces. If you can provide examples that will be great.",
  },
  {
    itemTitle: "How to implement queue using only stack?",
    postedBy: "Soumen Sau",
    subject: "Data Structure",
    timeOfposting: "11:25",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    votes: 21,
    doubtDesc:
      "Can anyone tell me how to how to implement a queue data structure using only stack. Implement a first in first out (FIFO) queue using only two stacks. The implemented queue should support all the functions of a normal queue (push, peek, pop, and empty). You must use only standard operations of a stack, which means only push to top, peek/pop from top, size, and is empty operations are valid. Depending on your language, the stack may not be supported natively. You may simulate a stack using a list or deque (double-ended queue) as long as you use only a stack's standard operations.",
  },
  {
    itemTitle: "What is bipartite graph",
    postedBy: "Rabbil Khan",
    subject: "Discrete Math",
    timeOfposting: "8:54 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 15,
    doubtDesc:
      "Please anyone tell what exactly is bipartite graph with proper examples.",
  },
  {
    itemTitle: "Difference between internal and external view.",
    postedBy: "Biswanath Bera",
    subject: "Database",
    timeOfposting: "Yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
    votes: 8,
    doubtDesc:
      "What is the difference between internal view and external view in database? Please give at least 5 to 7 differnces. If you can provide examples that will be great.",
  },
  {
    itemTitle: "How to implement queue using only stack?",
    postedBy: "Soumen Sau",
    subject: "Data Structure",
    timeOfposting: "11:25",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 21,
    doubtDesc:
      "Can anyone tell me how to how to implement a queue data structure using only stack. Implement a first in first out (FIFO) queue using only two stacks. The implemented queue should support all the functions of a normal queue (push, peek, pop, and empty). You must use only standard operations of a stack, which means only push to top, peek/pop from top, size, and is empty operations are valid. Depending on your language, the stack may not be supported natively. You may simulate a stack using a list or deque (double-ended queue) as long as you use only a stack's standard operations.",
  },
  {
    itemTitle: "What is bipartite graph",
    postedBy: "Rabbil Khan",
    subject: "Discrete Math",
    timeOfposting: "8:54 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1595956553066-fe24a8c33395?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    votes: 15,
    doubtDesc:
      "Please anyone tell what exactly is bipartite graph with proper examples.",
  },
  {
    itemTitle: "Difference between internal and external view.",
    postedBy: "Biswanath Bera",
    subject: "Database",
    timeOfposting: "Yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1544168190-79c17527004f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFsZSUyMHRlYWNoZXJ8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    votes: 8,
    doubtDesc:
      "What is the difference between internal view and external view in database? Please give at least 5 to 7 differnces. If you can provide examples that will be great.",
  },
  {
    itemTitle: "How to implement queue using only stack?",
    postedBy: "Soumen Sau",
    subject: "Data Structure",
    timeOfposting: "11:25",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1608681299041-cc19878f79f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 21,
    doubtDesc:
      "Can anyone tell me how to how to implement a queue data structure using only stack. Implement a first in first out (FIFO) queue using only two stacks. The implemented queue should support all the functions of a normal queue (push, peek, pop, and empty). You must use only standard operations of a stack, which means only push to top, peek/pop from top, size, and is empty operations are valid. Depending on your language, the stack may not be supported natively. You may simulate a stack using a list or deque (double-ended queue) as long as you use only a stack's standard operations.",
  },
  {
    itemTitle: "What is bipartite graph",
    postedBy: "Rabbil Khan",
    subject: "Discrete Math",
    timeOfposting: "8:54 am",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1589992896844-9b720813d1cb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1031&q=80",
    votes: 15,
    doubtDesc:
      "Please anyone tell what exactly is bipartite graph with proper examples.",
  },
  {
    itemTitle: "Difference between internal and external view.",
    postedBy: "Biswanath Bera",
    subject: "Database",
    timeOfposting: "Yesterday",
    profilePicOfPoster:
      "https://images.unsplash.com/photo-1611928506023-25ed62d1d04d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
    votes: 8,
    doubtDesc:
      "What is the difference between internal view and external view in database? Please give at least 5 to 7 differnces. If you can provide examples that will be great.",
  },
];
